import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AppFooter } from '~/components/footer.tsx';
import { AppNavbar } from '~/components/navbar.tsx';

export const Route = createFileRoute('/$pathLocale/_layout')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="h-full flex flex-col">
      <AppNavbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <AppFooter />
    </div>
  );
}
